import ClockIcon from "@redotech/redo-icons/clock-stopwatch.svg";
import { WaitForEventStep } from "@redotech/redo-model/advanced-flow/advanced-flow-db-parser";
import { RedoFeaturedIcon } from "@redotech/redo-web/arbiter-components/featured-icon/redo-featured-icon";
import { Flex } from "@redotech/redo-web/flex";
import { Text } from "@redotech/redo-web/text";
import { Handle, Position } from "@xyflow/react";
import { useMemo } from "react";
import { PartialWithRequiredType } from "../steps";
import { getPrettyEventName } from "../utils/event-utils";
import { BaseNode } from "./base-node";
import * as NodeCSS from "./node.module.css";

export interface WaitForEventNodeData {
  step: PartialWithRequiredType<WaitForEventStep>;
  deleteElements: (id: string) => void;
}

export function WaitForEventNode(data: {
  id: string;
  data: WaitForEventNodeData;
  selected?: boolean | undefined;
}) {
  const eventLabel = useMemo(() => {
    if (data.data.step.eventType) {
      return getPrettyEventName(data.data.step.eventType);
    } else {
      return undefined;
    }
  }, [data.data.step.eventType]);

  return (
    <BaseNode
      icon={<RedoFeaturedIcon color="warning" Icon={ClockIcon} size="xs" />}
      onDelete={() => data.data.deleteElements(data.id)}
      selected={data.selected}
      step={data.data.step}
      title="Wait for event"
    >
      <>
        <Handle position={Position.Top} type="target" />
        <Flex className={NodeCSS.fullWidth} dir="column" justify="flex-start">
          <Text fontSize="xxs">Event Type</Text>
          {eventLabel ? (
            <Text className={NodeCSS.valueText}>{eventLabel}</Text>
          ) : (
            <Text className={NodeCSS.placeholderText}>Needs configuration</Text>
          )}
        </Flex>
        <Handle position={Position.Bottom} type="source" />
      </>
    </BaseNode>
  );
}
